"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.startDataDogCdn = startDataDogCdn;

var _runtimeConfigHelper = require("./../../helpers/runtime-config-helper");

/**
 * DataDog logger
 *
 * @class DataDogHelper
 */
var isInitialized = false;

function init(applicationId, clientToken, version) {
  if (!isInitialized) {
    isInitialized = true;
    startDataDogCdn(applicationId, clientToken, version);
  }
}

function startDataDogCdn(applicationId, clientToken, version) {
  /* eslint-disable */
  (function (h, o, u, n, d) {
    h = h[d] = h[d] || {
      q: [],
      onReady: function onReady(c) {
        h.q.push(c);
      }
    };
    d = o.createElement(u);
    d.async = 1;
    d.src = n;
    n = o.getElementsByTagName(u)[0];
    n.parentNode.insertBefore(d, n);
  })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/datadog-rum-v4.js', 'DD_RUM');

  DD_RUM.onReady(function () {
    DD_RUM.init({
      applicationId: applicationId || '57874842-27be-409b-97cb-c78be7927ecc',
      clientToken: clientToken || 'pub41b912b31272a02a2e519020541fbd91',
      site: 'datadoghq.com',
      service: (0, _runtimeConfigHelper.getRuntimeConfig)()._app,
      env: (0, _runtimeConfigHelper.getRuntimeConfig)()._env,
      version: version || '0.0.1',
      sampleRate: 100,
      replaySampleRate: 100,
      // if not included - default 100
      trackInteractions: true,
      allowedTracingOrigins: (0, _runtimeConfigHelper.getRuntimeConfig)().env == 'prod' ? urlRegularExpressionsProduction : urlRegularExpressions
    });
  });
}

var resolveRegularExpression = {
  SITELIO: {
    name: 'sitelio',
    partnerId: 2,
    urlResolveRegularExpression: /\.sitelio\.((latest|qa|uat)\.wzdev\.co)$/,
    urlResolveRegularExpressionProduction: /\.sitelio\.com$/
  },
  WEBSITEBUILDER: {
    name: 'websitebuilder',
    partnerId: 3,
    urlResolveRegularExpression: /\.websitebuilder\.((latest|qa|uat)\.wzdev\.co)$/,
    urlResolveRegularExpressionProduction: /\.websitebuilder\.com$/,
    allowAnyOriginForOptions: true
  },
  SITEY: {
    name: 'sitey',
    partnerId: 5,
    urlResolveRegularExpression: /\.sitey\.((latest|qa|uat)\.wzdev\.co)$/,
    urlResolveRegularExpressionProduction: /\.sitey\.com$/
  },
  ECOMDASH: {
    name: 'ecomdash',
    partnerId: 80,
    urlResolveRegularExpression: /\.ecomdash\.((latest)\.wzdev\.co)$|\.((latest|qa|uat)\.svc\.ecomdash\.com)$/,
    urlResolveRegularExpressionProduction: /\.svc\.ecomdash\.com$/
  },
  SITEBUILDER: {
    name: 'sitebuilder',
    partnerId: 6,
    urlResolveRegularExpression: /\.sitebuilder\.((latest|qa|uat)\.wzdev\.co)$/,
    urlResolveRegularExpressionProduction: /\.sitebuilder\.com$/
  },
  GATOR: {
    name: 'gator',
    partnerId: 40,
    urlResolveRegularExpression: /\.gatordev\.co$/,
    urlResolveRegularExpressionProduction: /\.gator\.com$/
  },
  CREATIVEMAIL: {
    name: 'creativemail',
    partnerId: 60,
    urlResolveRegularExpression: /\.((latest|qa|uat)\.){1}creativ\.email$|\.((latest|qa|uat)\.){1}creativemail\.com$/,
    urlResolveRegularExpressionProduction: /\b(?!(latest|qa|uat)\b)\w+\.creativ\.email$|\b(?!(latest|qa|uat)\b)\w+\.creativemail\.com$/
  },
  WPBOOKINGS: {
    name: 'wpbookings',
    partnerId: 90,
    urlResolveRegularExpression: /\.((latest|qa|uat)\.){1}myschedulr\.com$/,
    urlResolveRegularExpressionProduction: /\b(?!(latest|qa|uat)\b)\w+\.myschedulr\.com$/,
    allowAnyOriginForOptions: true
  },
  CONSTANTCONTACT: {
    name: 'constantcontact',
    partnerId: 50,
    urlResolveRegularExpression: /\.ctctdev\.co$|\.((s1|l1)\.){1}constantcontact\.com$|\.((s1|l1)\.){1}roving\.com$/,
    urlResolveRegularExpressionProduction: /\.constantcontact\.online$|\b(?!(l1|s1)\b)\w+\.constantcontact\.com$|\b(?!(l1|s1)\b)\w+\.roving\.com$/
  },
  WPEDIT: {
    name: 'wpedit',
    partnerId: 70,
    urlResolveRegularExpression: /\.((latest|qa|uat)\.){1}wp-edit\.com$/,
    urlResolveRegularExpressionProduction: /\b(?!(latest|qa|uat)\b)\w+\.wp-edit\.com$/,
    allowAnyOriginForOptions: true
  },
  API_PARTNER: {
    name: 'api_partner',
    partnerId: null,
    urlResolveRegularExpression: /(\.((latest|qa|uat)\.){1}mywebsitebuilder\.com$|((?:-staging){1}\.yourhostingaccount\.com)$|\.((latest|qa|uat)\.)?2lin\.es$)/,
    urlResolveRegularExpressionProduction: /\b(?!(latest|qa|uat)\b)\w+\.mywebsitebuilder\.com$|^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+yourhostingaccount\.com$|\b(?!(latest|qa|uat)\b)\w+\.2lin\.es$/
  },
  WPDOIT: {
    name: 'wpdoit',
    partnerId: 152,
    urlResolveRegularExpression: /\.((latest|qa|uat)\.){1}wpdoit\.com$/,
    urlResolveRegularExpressionProduction: /\b(?!(latest|qa|uat)\b)\w+\.wpdoit\.com$/,
    allowAnyOriginForOptions: true
  },
  DOMAINDOTCOM: {
    name: 'domaincom',
    partnerId: 108,
    urlResolveRegularExpression: /((?:-staging){1}\.domain\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+domain\.com$/
  },
  HOSTGATOR: {
    name: 'hostgator',
    partnerId: null,
    // Do not send the partner id as hostgator has multiple
    urlResolveRegularExpression: /((?:-staging){1}\.hostgator\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+hostgator\.com$/
  },
  DOTSTER: {
    name: 'dotster',
    partnerId: 114,
    urlResolveRegularExpression: /((?:-staging){1}\.dotster\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+dotster\.com$/
  },
  HOMESTEAD: {
    name: 'homestead',
    partnerId: 103,
    urlResolveRegularExpression: /\.homestead\.((uat)\.wzdev\.co)$/,
    urlResolveRegularExpressionProduction: /\.homestead\.com$/
  },
  NETFIRMS: {
    name: 'netfirms',
    partnerId: 128,
    urlResolveRegularExpression: /((?:-staging){1}\.netfirms\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+netfirms\.com$/
  },
  MYDOMAIN: {
    name: 'mydomaincom',
    partnerId: 126,
    urlResolveRegularExpression: /((?:-staging){1}\.mydomain\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+mydomain\.com$/
  },
  IPAGE: {
    name: 'ipage',
    partnerId: 107,
    urlResolveRegularExpression: /((?:-staging){1}\.ipage\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+ipage\.com$/
  },
  BLUEHOST: {
    name: 'bluehost',
    partnerId: 101,
    urlResolveRegularExpression: /\.betabh\.com$|\.bluehost\.((latest|qa|uat)\.wzdev\.co)$/,
    urlResolveRegularExpressionProduction: /\.bluehost\.com$/,
    allowAnyOriginForOptions: true
  },
  BLUEHOSTINDIA: {
    name: 'bluehost_in',
    partnerId: 153,
    urlResolveRegularExpression: /((?:.beta){1}\.bluehost\.in)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\.beta)\b)[a-z\-]+\.)+bluehost\.in$/,
    allowAnyOriginForOptions: true
  },
  BLUEHOSTASIA: {
    name: 'bluehost_asia',
    partnerId: 154,
    urlResolveRegularExpression: /((?:.beta){1}\.bluehostasia\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\.beta)\b)[a-z\-]+\.)+bluehostasia\.com$/,
    allowAnyOriginForOptions: true
  },
  FASTDOMAIN: {
    name: 'fastdomain',
    partnerId: 149,
    urlResolveRegularExpression: /\.betafd\.com$/,
    urlResolveRegularExpressionProduction: /\.fastdomain\.com$/
  },
  HOSTMONSTER: {
    name: 'hostmonster',
    partnerId: 150,
    urlResolveRegularExpression: /\.betahm\.com$/,
    urlResolveRegularExpressionProduction: /\.hostmonster\.com$/
  },
  JUSTHOST: {
    name: 'justhost',
    partnerId: 146,
    urlResolveRegularExpression: /\.betajh\.com$/,
    urlResolveRegularExpressionProduction: /\.justhost\.com$/
  },
  BIGROCK: {
    name: 'bigrock',
    partnerId: 151,
    urlResolveRegularExpression: /((?:-staging){1}\.bigrock\.in)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+bigrock\.in$/
  },
  NETWORKSOLUTIONS: {
    name: 'networksolutions',
    partnerId: 157,
    urlResolveRegularExpression: /((?:-staging){1}\.networksolutions\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+networksolutions\.com$/
  },
  WEBDOTCOM: {
    name: 'webdotcom',
    partnerId: 158,
    urlResolveRegularExpression: /((?:-staging){1}\.web\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+web\.com$/
  },
  REGISTERDOTCOM: {
    name: 'registerdotcom',
    partnerId: 159,
    urlResolveRegularExpression: /((?:-staging){1}\.register\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+register\.com$/
  },
  CRAZYDOMAINS: {
    name: 'crazydomains',
    partnerId: 160,
    urlResolveRegularExpression: /((?:-staging){1}\.crazydomains\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+crazydomains\.com$/
  },
  SITEBEAT: {
    name: 'sitebeat',
    partnerId: 161,
    urlResolveRegularExpression: /((?:-staging){1}\.sitebeat\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+sitebeat\.com$/
  },
  WEBDOTCOMUK: {
    name: 'webdotcomuk',
    partnerId: 166,
    urlResolveRegularExpression: /((?:-staging){1}\.uk\.web\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+uk\.web\.com$/
  },
  NAMESECURE: {
    name: 'namesecure',
    partnerId: 167,
    urlResolveRegularExpression: /((?:-staging){1}\.namesecure\.com)$/,
    urlResolveRegularExpressionProduction: /^(https?:\/\/)?(\b(?!(?:.+\-staging)\b)[a-z\-]+\.)+namesecure\.com$/
  }
};
var brands = Object.keys(resolveRegularExpression);
var urlRegularExpressionsProduction = brands.map(function (brand) {
  return resolveRegularExpression[brand].urlResolveRegularExpressionProduction;
});
var urlRegularExpressions = brands.map(function (brand) {
  return resolveRegularExpression[brand].urlResolveRegularExpression;
});